import React from "react";
//import { useState } from 'react';

import "./App.css";

const Header = (props) => {
  
  //console.log(props)
  //const [language, setLanguage] = useState ("English")
  //console.log(language);

  //Definition of functions
 const chooseEnglish = (e) => {
    e.preventDefault();
    const language = e.target.value;
    props.setLanguage(language);
  };

  const chooseSpanish = (e) => {
    e.preventDefault();
    //console.log(e);
    //console.log(e.target.value);
    const language = e.target.value;
    props.setLanguage(language);
    //console.log("new Language: " + language);
  }; 

  return (
    <div className="Header">
      <div
        className="btn-group"
        role="group"
        aria-label="Basic radio toggle button group"
      >
        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio1"
          autoComplete="off"
          defaultChecked
          onChange={chooseEnglish}
          value="English"
          
        />
        <label className="btn btn-outline-primary" htmlFor="btnradio1">
          English
        </label>

        <input
          type="radio"
          className="btn-check"
          name="btnradio"
          id="btnradio2"
          autoComplete="off"
          onChange={chooseSpanish}
          value="Spanish"
          
        />
        <label className="btn btn-outline-primary" htmlFor="btnradio2">
          Español
        </label>
      </div>
    </div>
  );
};

export default Header;
